import type { ValuesType } from 'utility-types'

export const objectEntries: <T extends object>(obj: T) => [keyof T, ValuesType<T>][] = Object.entries
